/**
 * Global application configuration.
 * Can store run-time options, API urls, paths, execution flags and so on.
 * Automatically loaded on application initialization and available as app.config.
 */

'use strict';

// public
module.exports = {
    480: {
        main: {
            width: 606,
            height: 182,
            top: 40,
            left: 57
        },
        numpad: {
            width: 353,
            height: 146,
            top: 40,
            left: 183.5
        }
    },
    576: {
        main: {
            width: 606,
            height: 195,
            top: 40,
            left: 57
        },
        numpad: {
            width: 353,
            height: 146,
            top: 40,
            left: 183.5
        }
    },
    720: {
        main: {
            width: 1128,
            height: 260,
            top: 40,
            left: 76
        },
        numpad: {
            width: 504,
            height: 208,
            top: 40,
            left: 388
        }
    },
    1080: {
        main: {
            width: 1128 * 1.5,
            height: 260 * 1.5,
            top: 40 * 1.5,
            left: 76 * 1.5
        },
        numpad: {
            width: 504 * 1.5,
            height: 208 * 1.5,
            top: 40 * 1.5,
            left: 388 * 1.5
        }
    }
};
